import React, {useEffect, useState} from "react";
import VerticalBoxConnector from "./VerticalBoxConnector";
import {HostBubblePlaceHolder} from "./HostBubble";
import LineConnector from "./LineConnector";
import {createUseStyles} from "react-jss";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";
import {Theme} from "engage-client/theme";


export const BoxDimension = 134;
const TitleHeight = 24;
const TripleLineHeight = 80;

const useStyles = createUseStyles<Theme>((theme) => ({
	virtualHost: {
		display: "flex",
	},
	hostContainer: {
		display: "flex",
		flexDirection: "column",
		width: BoxDimension,
	},
	hostText: {
		padding: 1,
		textAlign: "center",
		backgroundColor: theme.presenterVideo.textBackground,
		height: TitleHeight,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	hostBox: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		height: BoxDimension,
		width: BoxDimension,
		backgroundColor: "rgba(3,3,3,0.3)",
		border: "1px solid #707070"
	},
	threeLineContainer: {
		paddingTop: BoxDimension / 2 + TitleHeight - TripleLineHeight / 2,
	}
}));

type VirtualHostProps = {
	embedURL: string
	connectorWidth: number
	showThreeLine:boolean
	hostName?:string
}

export default function VirtualHost({embedURL,connectorWidth,showThreeLine, hostName}:VirtualHostProps) {

	const classes = useStyles();
	const displayedHostName = hostName?.length ? hostName : "Host";
	return (
		<div className={classes.virtualHost}>
			<VerticalBoxConnector width={connectorWidth} connectionPointY={TitleHeight + BoxDimension / 2}/>
			<div className={classes.hostContainer}>
				<DisplayText variant={TextVariant.s20med} className={classes.hostText}>{displayedHostName}</DisplayText>
				<div className={classes.hostBox}>
					<HostBubblePlaceHolder embedURL={embedURL} width={114}/>
				</div>
			</div>
			{ showThreeLine ?
				<div className={classes.threeLineContainer}>
					<LineConnector numberOfLines={3} thickness={2} color="white" opacity={0.47}
								   width={14} height={TripleLineHeight}/>
				</div> : undefined
			}
		</div>
	);
}

const useMobileStyles = createUseStyles({
	mobileHost: {
		position: "absolute",
		top: 0,
		right: 0,
		//Give it some room above the Get Ready... label
		bottom: 10,
		left: 0,
		display: "flex",
		justifyContent: "center",
		alignItems: props => props.bottom ? "flex-end" : "center",
		transform: ({visible}) => visible ? "translateX(0)" : "translateX(calc(-50% - 100px))",
	}
});

type MobileVirtualHostProps = {
	embedURL: string
	visible: boolean
	bottom?: boolean
}

export function MobileVirtualHost({embedURL, visible, bottom = false}: MobileVirtualHostProps) {
	const classes = useMobileStyles({visible, bottom});

	// Location dep is passed into the host bubble as a mechanism for letting the host bubble know when to update
	// it's position.
	const [locationDep, setLocationDep] = useState(false);

	useEffect(() => {
		setLocationDep(locDep => !locDep);
	}, [visible]);

	return <div className={classes.mobileHost}>
		<HostBubblePlaceHolder embedURL={embedURL} dep={locationDep} />
	</div>;
}
